module.exports = __webpack_public_path__ + "img/ic_transsion_logo_normal.a80ce04.png";